 // rsti Facial Rekognition Auth UI - POC

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignInComponent } from './sign-in/sign-in.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { PrivateComponent } from './private/private.component';
import { AnswerChallengeComponent } from './answer-challenge/answer-challenge.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { IsAuthenticated, IsNotAuthenticated } from './auth.guard';
import { WhitelistComponent } from './whitelist/whitelist.component';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent, canActivate: [IsNotAuthenticated] },
  { path: 'sign-up', component: SignUpComponent, canActivate: [IsNotAuthenticated] },
  { path: 'image-auth', component: AnswerChallengeComponent, canActivate: [IsNotAuthenticated] },
  { path: 'whitelist', component: WhitelistComponent, canActivate: [IsNotAuthenticated] },
  { path: 'sign-out', component: SignOutComponent, canActivate: [IsAuthenticated] },
  { path: 'login', component: PrivateComponent, canActivate: [IsAuthenticated] },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
